export default [
    {
        path: '/admin/academic/course-skills',
        name: 'course-skill',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/course-skill/index.vue')
    }
]
